import React from 'react'
import {
	Container,
	Header,
	HeaderButton,
	Main,
	Spacer
} from './styled';
import theme from '../../../../styles/theme'
import styled from 'styled-components'

import { ChevronLeft } from '../../../../assets/icons';
import { useBack } from './BackContext';

const MobileLayout = ({ children }) => {
  const { backHandler } = useBack();

  return (
    <Container>
        <Header>
          <HeaderButton onClick={backHandler || undefined}>
            <ChevronLeft size={15} color={theme.colors.text.primaryText} />
          </HeaderButton>
          <Title size="18px" color="#000000ff">Portal clínicas</Title>
          <Spacer width="0.6" />
        </Header>

      <Main >{children}</Main>

    </Container>
  );
};

const Title = styled.h1`
    font-size: '18px';
    line-height: '24px';
    color: #000000ff;
    font-weight: 600;
    margin: 0;
`;

export default MobileLayout;
